module.exports = __webpack_public_path__ + "static/media/hypothesis1_active.42b53db0.png";